import { Handle, Position } from '@xyflow/react'

// Palette accent for the First/Last Frame Pose nodes — the LiveLink green, since
// they're sibling face-stream sources. Exported so BlueprintEditor's palette
// reuses it instead of adding a hex literal outside src/components/nodes/.
export const FACE_FRAME_POSE_COLOR = '#30d090'

/**
 * First/Last Frame Pose — FACE-graph source nodes that output the static face
 * pose published by the Stream First Frame / Stream Last Frame EVENT-graph
 * actions (a 1-frame clip in faceClipPlayer, sentinels in sentenceFrameClips.js).
 * Use like a LiveLink source: wire the `anim` output into a Blend / Blend by
 * Bool to ease the face into a sentence's opening (or closing) shape. Emits a
 * clip name — resolved by both the GLB head and the splat rig via
 * getBlendedWeights when LiveLink is off. See GraphEvaluator `firstFramePose` /
 * `lastFramePose`.
 */
function FramePoseShell({ selected, icon, title, desc }) {
  return (
    <div style={{
      background: selected ? '#0f2020' : '#091818',
      border: `2px solid ${selected ? '#20c080' : '#185040'}`,
      borderRadius: 6,
      padding: '10px 14px',
      minWidth: 180,
      color: '#ddd',
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
        <span style={{ fontSize: 15 }}>{icon}</span>
        <span style={{ color: '#40d0a0', fontWeight: 'bold', fontSize: 11, letterSpacing: 0.5 }}>{title}</span>
      </div>
      <div style={{ color: '#336650', fontSize: 10 }}>{desc}</div>
      <Handle type="source" position={Position.Right} id="anim" style={{ background: '#185040', width: 10, height: 10 }} />
    </div>
  )
}

export function FirstFramePoseNode({ selected }) {
  return <FramePoseShell selected={selected} icon="⏭" title="FIRST FRAME POSE" desc="Sentence's first frame · via Stream First Frame" />
}

export function LastFramePoseNode({ selected }) {
  return <FramePoseShell selected={selected} icon="⏹" title="LAST FRAME POSE" desc="Sentence's last frame · via Stream Last Frame" />
}
